import {store} from '../client'
import { setNotification, openNotification, closeNotification, setClassName } from '../actions/notification'


class NotificationService {

  static notify(message) {
    store.dispatch(setNotification(message));
    store.dispatch(setClassName(''));
    store.dispatch(openNotification());
  }

  static error(data) {
    let message = '';
    if (typeof(data) == 'object')
      for (var key in data) {
        message = Array.isArray(data[key]) ? data[key][0] : data[key];
      }
    else
      message = data;
    store.dispatch(setNotification(message));
    store.dispatch(setClassName('error'));
    store.dispatch(openNotification());
  }

  static close() {
    store.dispatch(closeNotification())
  }

}

export default NotificationService;


// WEBPACK FOOTER //
// ./services/notification.js